// extracted by mini-css-extract-plugin
export var actionIcon = "_ku-0";